module.exports = __webpack_public_path__ + "assets/images/C-icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/C-icon.png
// module id = 1323
// module chunks = 1